module.exports = __webpack_public_path__ + "img/够健康 够快乐.2528a1a2.png";